<div class="grid min-h-dvh place-items-center bg-info p-4 text-info-content">
  <div
    data-gate
    class="w-full max-w-sm border-[3px] border-neutral bg-base-100 p-5 text-base-content brutal sm:p-6"
  >
    <p class="font-mono text-xs font-bold uppercase opacity-70">{{ t().here }}</p>
    <h1 class="mt-1 font-mono text-3xl font-bold tracking-tighter uppercase">
      corti<span class="bg-primary px-1 text-primary-content">.to</span>
      <span class="ml-1 bg-neutral px-1 text-neutral-content">dev</span>
    </h1>
    <p class="mt-3 text-sm">{{ t().lead }}</p>

    <div class="mt-5 flex gap-2">
      <div class="input w-full border-[3px] border-neutral bg-base-100 brutal-sm">
        <input
          #field
          type="password"
          [placeholder]="t().placeholder"
          [attr.aria-label]="t().label"
          autocomplete="off"
          (keydown.enter)="try()"
        />
      </div>
      <button
        type="button"
        data-gate-enter
        class="btn border-[3px] border-neutral bg-primary font-bold uppercase brutal-sm brutal-press"
        (click)="try()"
      >
        {{ t().enter }}
      </button>
    </div>

    @if (refused()) {
      <p data-gate-refused class="mt-3 text-sm font-bold text-error">{{ t().refused }}</p>
    }

    <a
      class="mt-5 inline-flex items-center gap-1 font-mono text-xs font-bold uppercase hover:bg-primary hover:text-primary-content"
      href="https://corti.to"
    >
      <span class="material-symbols-outlined text-base">open_in_new</span> {{ t().real }}
    </a>
  </div>
</div>
